import {
  Backend,
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { AdminEnterprisesCollection } from './admin-enterprises.types';

export function adminEnterprisesBackend(): Backend<AdminEnterprisesCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'users/0.1/admin/enterprises/',
      params: {
        enterprises: ids,
        names: getQueryParamValue(query, 'name'),
        internal_names: getQueryParamValue(query, 'internal_name'),
        seo_urls: getQueryParamValue(query, 'seo_url'),
        // We want to include all test enterprises for now.
        // This is because we don't have any specific logic around test enterprises as of yet.
        // Once we have a better picture of what that should be, then we may update this.
        ignore_test: false,
      },
    }),
    push: (authUid, enterprise) => ({
      endpoint: 'users/0.1/admin/enterprises/',
      payload: {
        name: enterprise.name,
        internal_name: enterprise.internal_name,
        seo_url: enterprise.seo_url,
        is_test_enterprise: enterprise.is_test_enterprise,
      },
    }),
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
